import { render, staticRenderFns } from "./Discount_SubCategoryList.vue?vue&type=template&id=38dcba8a&scoped=true&"
import script from "./Discount_SubCategoryList.vue?vue&type=script&lang=js&"
export * from "./Discount_SubCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./Discount_SubCategoryList.vue?vue&type=style&index=0&id=38dcba8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dcba8a",
  null
  
)

export default component.exports